/**
 * `Balm DTX` rather than `Balm`: it is the name the commercial site and the app's Open Graph tags
 * use, so a tab, a bookmark and a share card all say the same thing (IPD-3003).
 */
export const SITE_NAME = 'Balm DTX';

/** `Sign up | Balm DTX` for a page that names itself, the product alone for one that does not. */
export function buildDocumentTitle(pageTitle?: string | null): string {
  const named = pageTitle?.trim();
  return named ? `${named} | ${SITE_NAME}` : SITE_NAME;
}
